import {riskTypeIds} from '../../../util/uiconstants';
import Utility from '../../../util/utilityfunctions';

import selectComponentRisks from './selectComponentRisks';

export default (relatedRisks = []) => {
	const componentRisks = selectComponentRisks();
	const relatedComponentRisks = relatedRisks.map(({componentRiskId}) => ({
		...componentRisks.find(({riskId}) => riskId === componentRiskId)
	}));

	const sortedRelatedRisks = [];

	Object.values(riskTypeIds).forEach((typeId) => {
		const filteredByTypeId = relatedComponentRisks.filter((r) => r.riskTypeId === typeId);
		const sorted = Utility.sortListData(filteredByTypeId, 'riskName');
		sortedRelatedRisks.push(...sorted);
	});

	return sortedRelatedRisks;
};
